var u = (n, p, r) => new Promise((s, i) => {
  var a = (e) => {
    try {
      m(r.next(e));
    } catch (t) {
      i(t);
    }
  }, l = (e) => {
    try {
      m(r.throw(e));
    } catch (t) {
      i(t);
    }
  }, m = (e) => e.done ? s(e.value) : Promise.resolve(e.value).then(a, l);
  m((r = r.apply(n, p)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import y from "./houseTypeEditDialog.ce.vue.js";
import { vCopyVueucStylesToShadowDom as h } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { defineComponent as C, useTemplateRef as _, withDirectives as g, openBlock as N, createBlock as T, withCtx as d, createVNode as c } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as b } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as o } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import S from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import w from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import D from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const V = /* @__PURE__ */ C({
  __name: "index.ce",
  setup(n, { expose: p }) {
    const r = _("houseTypeEditDialogRefs");
    let s = null;
    const i = b(), a = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, l = (e) => u(this, null, function* () {
      var t;
      return (t = r.value) == null || t.open({
        customerId: e.customerId || "",
        houseTypeNumberJson: e.houseTypeNumberJson || "",
        signApplyId: e.signApplyId || "",
        id: e.id || "",
        businessType: e.businessType || "",
        applyCode: e.applyCode || "",
        quantity: Number(e.quantity) || 0,
        isNeedSave: e.isNeedSave || !1
      }), new Promise((f) => {
        s = f;
      });
    }), m = (e) => {
      s && (s(e), s = null);
    };
    return p({ open: l }), (e, t) => g((N(), T(o(D), {
      locale: o(S),
      "date-locale": o(w),
      "theme-overrides": a,
      "style-mount-target": o(i)
    }, {
      default: d(() => [
        c(o(R), { to: o(i) }, {
          default: d(() => [
            c(y, {
              ref_key: "houseTypeEditDialogRefs",
              ref: r,
              onSubmit: m
            }, null, 512)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"])), [
      [o(h), o(i)]
    ]);
  }
});
export {
  V as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/house-type-edit-dialog/index.ce.vue2.js
// module id = 1257
// module chunks = 41